import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

import { RootState } from '@root/app.state';
import * as CoreActions from '@core/core.actions';
import { go } from '@platform/router.actions';
import { RouteGuard } from '@platform/routing/route.guard';
import { selectUserOrganizationUnits } from '@core/core.selectors';
import { firstValueFrom } from 'rxjs';
import { ResourceStatuses } from '@platform/shared/resource.state';

@Injectable({
  providedIn: 'root',
})
export class CreateUserGuard implements RouteGuard {
  constructor(private store$: Store<RootState>) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    return await this.loadAndWaitForOrganizationUnits(route);
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean> {
    return await this.loadAndWaitForOrganizationUnits(childRoute.parent!);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private async loadAndWaitForOrganizationUnits(route: ActivatedRouteSnapshot): Promise<boolean> {
    this.store$.dispatch(CoreActions.clearCreatedUser());
    this.store$.dispatch(CoreActions.loadUserOrganizationUnits());

    const organizationUnitsState = await firstValueFrom(
      this.store$.pipe(
        select(selectUserOrganizationUnits),
        first((x) => x.status === ResourceStatuses.FAILED || x.status === ResourceStatuses.SUCCEEDED),
      ),
    );

    const canActivate = organizationUnitsState.status === ResourceStatuses.SUCCEEDED;
    if (!canActivate) {
      this.store$.dispatch(go({ path: ['error'] }));
    }

    return canActivate;
  }
}
